var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 2V4M5.5 2V4",
    stroke: "#616975",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4955 13H11.5045M11.4955 17H11.5045M15.491 13H15.5M7.5 13H7.50897M7.5 17H7.50897",
    stroke: "#616975",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 8H20",
    stroke: "#616975",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.99609 12.2432C1.99609 7.88594 1.99609 5.70728 3.24821 4.35364C4.50033 3 6.51558 3 10.5461 3H12.4461C16.4766 3 18.4919 3 19.744 4.35364C20.9961 5.70728 20.9961 7.88594 20.9961 12.2432V12.7568C20.9961 17.1141 20.9961 19.2927 19.744 20.6464C18.4919 22 16.4766 22 12.4461 22H10.5461C6.51558 22 4.50033 22 3.24821 20.6464C1.99609 19.2927 1.99609 17.1141 1.99609 12.7568V12.2432Z",
    stroke: "#616975",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 8H20.5",
    stroke: "#616975",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.dd0f3e2b2f8328a2aacc1fba8c11570d.svg";
export { ForwardRef as ReactComponent };